define([
	"jquery",
	"underscore",
	"marionette",
	"behaviors/form_errors_behavior",
	"backbone.syphon"
], function($, _, Marionette, FormErrorsBehavior) {
	return Marionette.View.extend({
		el: '#content_layout',

		behaviors: {
			formErrors: {
				behaviorClass: FormErrorsBehavior
			}
		},

		ui: {
			'deposit':'#deposit_btn',
			'currencySelect':'#currency_abbr',
			'amount' : '#amount',
		},

		events:{
			'keyup @ui.amount': 'updateExpected',
		},

		initialize: function(){
			this.bindUIElements();

			if(window.form_error)
			{
				this.triggerMethod('show:errors', window.form_error);
				window.form_error = null;
			}
		},

		updateExpected : function() {
			const amount = $('#amount').val();
			const fx_rate = window.fx_rates;
			const amountUsd = (amount * fx_rate).toFixed(2);
			$('#expected_amount').text(`$ ${amountUsd}`);
		},
	});
});
